import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
export var useButtonProps = function useButtonProps() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var deviceType = useDeviceType();
  return useMemo(function () {
    return _objectSpread(_objectSpread({}, getDefaultButtonProps(deviceType)), props);
  }, [props, deviceType]);
};

function getDefaultButtonProps(deviceType) {
  switch (deviceType) {
    case 'phone':
      return {
        text: 'Получить консультацию',
        theme: 'fill_secondary',
        size: 'M',
        fullWidth: true
      };

    case 'tablet':
      return {
        text: 'Получить консультацию',
        theme: 'fill_secondary',
        size: 'M',
        fullWidth: true
      };

    case 'desktop':
      return {
        text: 'Получить консультацию',
        theme: 'fill_white_primary',
        size: 'M'
      };
  }
}